import OnboardingChecklist from '@/components/user/onboarding/checklist/OnboardingChecklist.vue';
import moment from 'moment/moment';

export default {
  name: 'Offboarding',
  props: {
    userApiId: {
      default: null
    }
  },

  components: {
    OnboardingChecklist
  },

  data () {
    return {
      componentKey: 1,
      isLoading: false,
      job_position: null,
      planned_end_date: null,
      job_positions: [{ value: 'primary', text: 'Primārais amats' }],
      minDate: moment().subtract(2, 'day').format('YYYY-MM-DD')
    };
  },

  computed: {
  },

  methods: {
    loadPosition () {
      this.isLoadingPosition = true;
      this.ApiRequest.request(`user/${this.userApiId}/offboarding/get-position`, this.ApiRequest.REQUEST_GET, { date: this.planned_end_date, job_position: this.job_position }, (response) => {
        this.isLoadingPosition = false;
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else if (response.data) {
          if (response.data) {
            this.minDate = response.data.min_date
            if (response.data.date) {
              this.job_position = 'primary';
              this.planned_end_date = response.data.date;
            }
          }
        }
      });
    },
    savePlannedEndDate () {
      this.isLoading = true;
      this.ApiRequest.request(`user/${this.userApiId}/offboarding/update-date`, this.ApiRequest.REQUEST_PATCH, { date: this.planned_end_date, job_position: this.job_position }, (response) => {
        this.isLoading = false;
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else if (response.data) {
          if (response.data === 'generated') {
            this.componentKey++;
          }
        }
      });
    }
  },

  mounted () {
    this.loadPosition();
  }
}
